import script from "./esWaitingRoomBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./esWaitingRoomBadge.vue?vue&type=script&setup=true&lang=ts"

import "./esWaitingRoomBadge.vue?vue&type=style&index=0&id=57b846f4&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57b846f4"]])

export default __exports__